$ = require 'jquery'
Elements = require './elements'
Loader = require './loader'
{ defaults } = require 'lodash'
{ getBgImg } = require '../../components/css-val'

module.exports =
class SpriteAnime

  defOpts =
    fps    : 30
    loop   : false

  constructor: (@el, opts = {}) ->
    { @fps, @loop } = defaults opts, defOpts

    @ms            = 1000 / @fps
    @startTime     = 0
    @animateHandle = 0
    @rate          = 1
    @frame         = null
    @index         = 0

    @$window = Elements.$window
      .one
        'pagesLoaded' : @onPagesLoaded
        'imagesLoaded': @onImagesLoaded

  start: (cb = null) =>
    return if @animateHandle
    @animate cb

  end: =>
    window.cancelAnimationFrame @animateHandle
    @animateHandle = 0

  onPagesLoaded: =>
    @$wrap = $ @el

    @canvas = document.createElement 'canvas'

    return if !@canvas or !@canvas.getContext
    @$wrap.get(0).appendChild @canvas
    @ctx = @canvas.getContext '2d'

    @image = new Image()
    @image.src = getBgImg @$wrap

    @reset()

  onImagesLoaded: =>
    @imageLoaded()

  reset: =>
    @ctx.clearRect 0, 0, @wrapW, @wrapH

    @wrapW = @$wrap.width()
    @wrapH = @$wrap.height()

    @canvas.width  = @wrapW
    @canvas.height = @wrapH

    @rate  = @wrapW / @image.width
    @frame = Math.round @image.height * @rate / @wrapH

    @ctx.drawImage @image, 0, -(@wrapH * @index), @wrapW, (@wrapH * @frame)

  imageLoaded: =>
    @$wrap.css 'background', 'none'

    @ctx.drawImage @image, 0, 0, @wrapW, @wrapH

    @reset()

    @$window.on 'resize', @reset

  animate: (cb = {}) =>
    if @ms >= (new Date().getTime() - @startTime)
      @animateHandle = window.requestAnimationFrame(@animate.bind(this, cb))
      return

    @animateHandle = window.requestAnimationFrame(@animate.bind(this, cb))
    @startTime = new Date().getTime()

    return if !@frame

    @ctx.clearRect 0, 0, @wrapW, @wrapH

    @ctx.drawImage @image, 0, -(@wrapH * @index), @wrapW, (@wrapH * @frame)

    if (@frame - 1) > @index
      @index++
    else
      if @loop
        @index = 0
      else
        cb() if cb
        @end()



// WEBPACK FOOTER //
// ./webpack/requires/pc/views/sprite-anime.coffee